"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_circle_info_fill_style_1 = __importDefault(require("./uicon.circle.info.fill.style"));
class UiconCircleInfoFill extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.90026 27.3146C11.0835 28.7734 13.6503 29.552 16.276 29.552C19.7959 29.5483 23.1705 28.1484 25.6595 25.6595C28.1484 23.1705 29.5483 19.7959 29.552 16.276C29.552 13.6503 28.7734 11.0835 27.3146 8.90025C25.8558 6.71703 23.7824 5.01541 21.3565 4.01058C18.9306 3.00575 16.2613 2.74284 13.686 3.2551C11.1107 3.76736 8.74515 5.03177 6.88846 6.88845C5.03178 8.74514 3.76736 11.1107 3.2551 13.686C2.74284 16.2613 3.00575 18.9306 4.01058 21.3565C5.01541 23.7824 6.71703 25.8558 8.90026 27.3146ZM18.036 14.29L16.389 22.064H13.701L15.335 14.29H18.036ZM18.39 12.688L18.852 10.488H16.152L15.69 12.688H18.39Z", className: classes.fill }, void 0) }), void 0));
        };
    }
}
UiconCircleInfoFill.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconCircleInfoFill.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_circle_info_fill_style_1.default)(UiconCircleInfoFill);
//# sourceMappingURL=uicon.circle.info.fill.js.map